import loadable from '@loadable/component';

// 懒加载组件
const DrugItemManagement = loadable(() => import('./drugItemManagement/DrugItemManagement'));
const DrugExpiryManagement = loadable(() => import('./drugExpiryManagement/DrugExpiryManagement'));
const DrugStorageStock = loadable(() => import('./drugStorageStock/DrugStorageStock'));

export const subRoutes = [
  {
    path: '/DrugItemManagement',
    component: DrugItemManagement
  },
  {
    path: '/DrugExpiryManagement',
    component: DrugExpiryManagement
  },
  {
    path: '/DrugStorageStock',
    component: DrugStorageStock
  }
];
